import type { HttpClient } from '../http/types';
import type {
  BackendCollaborator,
  BackendCollaboratorHourlyCost,
  CreateBackendCollaboratorPayload,
  UpdateBackendCollaboratorPayload,
} from '../types/collaborator';
import type { AssignDirectLeaderPayload, BackendReportingLine } from '../types/leadership';
import { ENDPOINTS } from './endpoints';

export function createCollaboratorsApi(http: HttpClient) {
  return {
    list: () => http.get<BackendCollaborator[]>(ENDPOINTS.collaborators.root),

    byId: (id: string) => http.get<BackendCollaborator>(ENDPOINTS.collaborators.byId(id)),

    create: (payload: CreateBackendCollaboratorPayload) =>
      http.post<BackendCollaborator>(ENDPOINTS.collaborators.root, payload),

    update: (id: string, payload: UpdateBackendCollaboratorPayload) =>
      http.patch<BackendCollaborator>(ENDPOINTS.collaborators.byId(id), payload),

    deactivate: (id: string) => http.post<BackendCollaborator>(ENDPOINTS.collaborators.deactivate(id)),

    activate: (id: string) => http.post<BackendCollaborator>(ENDPOINTS.collaborators.activate(id)),

    /** PUT — define (ou, com amount:null, remove) o custo hora. Requer ADMIN. */
    setHourlyCost: (id: string, amount: number | null) =>
      http.put<BackendCollaboratorHourlyCost>(ENDPOINTS.collaborators.hourlyCost(id), { amount }),

    /** GET — custo hora em claro. Requer ADMIN. */
    getHourlyCost: (id: string) =>
      http.get<BackendCollaboratorHourlyCost>(ENDPOINTS.collaborators.hourlyCost(id)),

    /** POST — define o líder direto do colaborador (relação pessoa → pessoa). */
    assignDirectLeader: (id: string, payload: AssignDirectLeaderPayload) =>
      http.post<BackendReportingLine>(ENDPOINTS.collaborators.directLeader(id), payload),

    /** DELETE — remove o líder direto, quando houver. */
    removeDirectLeader: (id: string) => http.delete<void>(ENDPOINTS.collaborators.directLeader(id)),

    /** GET — líder direto atual, ou `null`. */
    getDirectLeader: (id: string) =>
      http.get<BackendReportingLine | null>(ENDPOINTS.collaborators.directLeader(id)),
  };
}

export type CollaboratorsApi = ReturnType<typeof createCollaboratorsApi>;
